import { z } from 'zod';

export const issueEnglishIqHandoffV1RequestSchema = z.object({
  shareId: z.string().min(6).max(64),
  visitorId: z.string().min(1).max(128),
});

export type IIssueEnglishIqHandoffV1Request = z.infer<typeof issueEnglishIqHandoffV1RequestSchema>;
